import(/* webpackMode: "eager" */ "/codebuild/output/src1481071709/src/FasTraxApp/app/page.tsx");
